module.exports = __webpack_public_path__ + "static/media/call.e58a75ce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/call.svg
// module id = 1394
// module chunks = 1